import { render, staticRenderFns } from "./InstallAppCard.vue?vue&type=template&id=7c6cdbf3&scoped=true"
import script from "./InstallAppCard.vue?vue&type=script&lang=js"
export * from "./InstallAppCard.vue?vue&type=script&lang=js"
import style0 from "./InstallAppCard.vue?vue&type=style&index=0&id=7c6cdbf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6cdbf3",
  null
  
)

export default component.exports